import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";
import Types from "constants/Types";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ListItemText from "@material-ui/core/ListItemText";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Reservations',
		url: '/reservations',
		icon: 'calendar-check-o',
	},
];

export default class Reservation extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.question = null;
		this.state.question_binary_id = null;

		this.state.anchorGen = null;
	}

	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	updateData = (id, binary_id) => {
		this.setState({
			question: id,
			question_binary_id: binary_id,
		})
	};

	printPdf = (form) => async () => {
		this.handleClose();
		let model = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);

		model.object.form = form;
		model.parent = this.props.match.params.id;

		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return;
		}

		this.setState({tab: 'forms'})

		this.refreshPage();
	};

	render() {
		let {anchorGen} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/reservations/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button
						size="sm"
						color="primary"
						aria-owns={anchorGen ? 'anchorGen' : null}
						aria-haspopup="true"
						onClick={this.handleOpen('anchorGen')}
					>
						<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate Form
					</Button>
					<Menu
						id="anchorGen"
						anchorEl={anchorGen}
						open={Boolean(anchorGen)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'left', vertical: 'top'}}
					>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="General Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(9)}>
							<ListItemText inset primary="Form 2 - Notice of Firearms Manufactured or Imported"/>
						</MenuItem>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="Dealer Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(6)}>
							<ListItemText inset primary="Form 3 - Application for Tax-Exempt Transfer of Firearm"/>
						</MenuItem>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="Customer & Legal Entity / Trust Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(15)}>
							<ListItemText inset primary="Form 4 - Application for Tax Paid Transfer and Registration of Firearms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(11)}>
							<ListItemText inset primary="Form 5 - Application for Tax Exempt Transfer and Registration of Firearm"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(10)}>
							<ListItemText inset primary="Form 23 - Responsible Person Questionnaire"/>
						</MenuItem>
						<MenuItem style={{backgroundColor: '#E0E0E0'}}>
							<ListItemText primary="Except Forms"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(12)}>
							<ListItemText inset primary="Form 9 - Application and Permit for Permanent Exportation of Firearms"/>
						</MenuItem>
					</Menu>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Reservation" value={'details'}/>
					<Tab label="Eligibility" value={'eligibility'}/>
					<Tab label="Forms" value={'forms'}/>
					<Tab label="Change Log" value={'logs'}/>
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Reservation
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateData={this.updateData}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						updateName={this.updateName}
					/>
				</div>
				{this.state.tab === 'eligibility' &&
				<Objects.ReservationEligibility
					id={this.state.question}
					binary_id={this.state.question_binary_id}
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
				/>}
				{this.state.tab === 'forms' &&
				<Collections.Forms
					parent={this.props.match.params.id}
					forForm={Types.Transactions_Collections_Forms._name}
					url={'/transactions/[PARENT]/collections_forms'}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'logs' &&
				<Collections.LogsReservations
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		);
	}
};
